import { debounce } from "lodash";
import { useCallback, useEffect, useMemo, useState } from "react";
import {
  clearAnyaDraft,
  getAnyaDraft,
  setAnyaDraft,
} from "utils/localStorageUtils";

const SAVE_INTERVAL = 5000;

export default function useAnyaDraft() {
  const [initialDraft] = useState(() => getAnyaDraft());

  const saveDraft = useMemo(
    () =>
      debounce((value: string) => setAnyaDraft(value.trim()), SAVE_INTERVAL),
    [],
  );

  const clearDraft = useCallback(() => {
    saveDraft.cancel();
    clearAnyaDraft();
  }, [saveDraft]);

  useEffect(() => () => saveDraft.flush(), [saveDraft]);

  return { initialDraft, saveDraft, clearDraft };
}
